import CommentNotifications from './CommentNotifications';

export default CommentNotifications;
